<div class="clientlist-container">
  <div class="clientlist-content">

    <!-- ═══════════════ Header ═══════════════ -->
    <div class="list-header">

      <h5>
        <i class="bi bi-calendar2-check me-2"></i>
        Appointments
      </h5>

      <div class="list-actions">

        <!-- Date preset: a shortcut that fills in the range below. -->
        <div class="tool-wrap" (click)="$event.stopPropagation()">
          <select class="tool-select"
                  [ngModel]="datePreset"
                  (ngModelChange)="selectPreset($event)">
            <option value="custom" *ngIf="datePreset === 'custom'">Custom</option>
            <option *ngFor="let option of datePresets" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <!-- Date range -->
        <div class="tool-wrap" (click)="$event.stopPropagation()">
          <button class="tool-btn" (click)="toggleDateMenu($event)">
            <i class="bi bi-calendar3"></i>
            <span class="tool-text">{{ dateRangeLabel }}</span>
            <i class="bi bi-chevron-down tool-caret"></i>
          </button>

          <div class="tool-menu" *ngIf="showDateMenu">
            <div class="menu-title">Date range</div>

            <label class="menu-label">From</label>
            <input type="date" class="form-control" [(ngModel)]="draftStart">

            <label class="menu-label">To</label>
            <input type="date" class="form-control" [(ngModel)]="draftEnd">

            <div class="menu-actions">
              <button class="btn btn-link btn-clear" (click)="clearDateRange()">
                Clear
              </button>
              <button class="btn btn-apply" (click)="applyDateRange()">
                Apply
              </button>
            </div>
          </div>
        </div>

        <!-- Search -->
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent" style="border:0">
              <i class="bi bi-search"></i>
            </span>

            <input type="text"
                   class="form-control"
                   style="padding:0;border:0"
                   placeholder="Search client or lawyer..."
                   [(ngModel)]="searchQuery"
                   (input)="onSearch()"
                   (keyup.enter)="onSearch()">

            <span class="input-group-text bg-transparent"
                  *ngIf="searchQuery"
                  (click)="clearSearch()"
                  style="cursor:pointer">
              <i class="bi bi-x-circle"></i>
            </span>
          </div>
        </div>

      </div>

    </div>

    <!-- ═══════════════ Summary cards ═══════════════ -->
    <div class="summary-grid" [class.summary-loading]="summaryLoading">

      <!-- Total Appointments -->
      <div class="summary-card">
        <div class="summary-top">
          <div class="summary-icon icon-blue">
            <i class="bi bi-calendar2-week"></i>
          </div>
          <div class="summary-text">
            <div class="summary-label">Total Appointments</div>
            <div class="summary-value">
              {{ summary?.total_appointments?.total || 0 }}
            </div>
          </div>
        </div>

        <div class="summary-foot">
          <span class="foot-item">
            Completed + Ongoing
            <strong class="text-success">
              {{ summary?.total_appointments?.completed_and_ongoing || 0 }}
            </strong>
          </span>
          <span class="foot-divider"></span>
          <span class="foot-item">
            Upcoming
            <strong class="text-primary">
              {{ summary?.total_appointments?.upcoming || 0 }}
            </strong>
          </span>
          <span class="foot-divider"></span>
          <span class="foot-item">
            Cancelled
            <strong class="text-danger">
              {{ summary?.total_appointments?.cancelled || 0 }}
            </strong>
          </span>
        </div>
      </div>

      <!-- Total Payment Received -->
      <div class="summary-card">
        <div class="summary-top">
          <div class="summary-icon icon-green">
            <i class="bi bi-currency-rupee"></i>
          </div>
          <div class="summary-text">
            <div class="summary-label">Total Payment Received</div>
            <div class="summary-value">
              {{ money(summary?.payment_received?.amount) }}
            </div>
          </div>
        </div>

        <div class="summary-foot">
          <span class="foot-item foot-muted">
            {{ summary?.payment_received?.note || 'Includes GST, Platform Fee &amp; Service Fee' }}
          </span>
        </div>
      </div>

      <!-- Total Settlement - Lawyers -->
      <div class="summary-card">
        <div class="summary-top">
          <div class="summary-icon icon-purple">
            <i class="bi bi-people-fill"></i>
          </div>
          <div class="summary-text">
            <div class="summary-label">Total Settlement - Lawyers</div>
            <div class="summary-value">
              {{ money(settlementAmount) }}
            </div>
          </div>
        </div>

        <!-- Each slice headlines its own amount above; the lit one is what
             the card is currently showing. -->
        <div class="summary-foot">
          <ng-container *ngFor="let slice of settlementSlices; let first = first">
            <span class="foot-divider" *ngIf="!first"></span>

            <button type="button"
                    class="foot-toggle"
                    [class.active]="settlementSlice === slice.value"
                    [attr.aria-pressed]="settlementSlice === slice.value"
                    (click)="selectSettlementSlice(slice.value)">
              {{ slice.label }}
              <strong [ngClass]="{
                        'text-success': slice.value === 'completed',
                        'text-warning': slice.value === 'pending',
                        'text-danger':  slice.value === 'failed'
                      }">
                {{ settlementCount(slice.value) }}
              </strong>
            </button>
          </ng-container>
        </div>
      </div>

      <!-- Total Refunded - Clients -->
      <div class="summary-card">
        <div class="summary-top">
          <div class="summary-icon icon-orange">
            <i class="bi bi-arrow-counterclockwise"></i>
          </div>
          <div class="summary-text">
            <div class="summary-label">Total Refunded - Clients</div>
            <div class="summary-value">
              {{ money(summary?.refunded?.amount) }}
            </div>
          </div>
        </div>

        <div class="summary-foot">
          <span class="foot-item">
            No. of Cancellations
            <strong class="text-danger">
              {{ summary?.refunded?.cancellations || 0 }}
            </strong>
          </span>
        </div>
      </div>

    </div>

    <!-- ═══════════════ Filter bar ═══════════════ -->
    <div class="filter-bar">

      <div class="filter-group">

        <!-- Appointment Status -->
        <div class="tool-wrap" (click)="$event.stopPropagation()">
          <button class="tool-btn"
                  [class.has-value]="applied.appointment_status.length"
                  (click)="toggleDropdown('appointment_status', $event)">
            <span class="tool-text">
              {{ dropdownLabel('appointment_status', 'Appointment Status') }}
            </span>
            <i class="bi bi-chevron-down tool-caret"></i>
          </button>

          <div class="tool-menu check-menu" *ngIf="openDropdown === 'appointment_status'">
            <label class="check-item" *ngFor="let option of options.appointment_status">
              <input type="checkbox"
                     [checked]="isChecked('appointment_status', option.value)"
                     (change)="toggleOption('appointment_status', option.value)">
              <span>{{ option.label }}</span>
            </label>
          </div>
        </div>

        <!-- Payment Status -->
        <div class="tool-wrap" (click)="$event.stopPropagation()">
          <button class="tool-btn"
                  [class.has-value]="applied.payment_status.length"
                  (click)="toggleDropdown('payment_status', $event)">
            <span class="tool-text">
              {{ dropdownLabel('payment_status', 'Payment Status') }}
            </span>
            <i class="bi bi-chevron-down tool-caret"></i>
          </button>

          <div class="tool-menu check-menu" *ngIf="openDropdown === 'payment_status'">
            <label class="check-item" *ngFor="let option of options.payment_status">
              <input type="checkbox"
                     [checked]="isChecked('payment_status', option.value)"
                     (change)="toggleOption('payment_status', option.value)">
              <span>{{ option.label }}</span>
            </label>
          </div>
        </div>

        <!-- Settlement Status -->
        <div class="tool-wrap" (click)="$event.stopPropagation()">
          <button class="tool-btn"
                  [class.has-value]="applied.settlement_status.length"
                  (click)="toggleDropdown('settlement_status', $event)">
            <span class="tool-text">
              {{ dropdownLabel('settlement_status', 'Settlement Status') }}
            </span>
            <i class="bi bi-chevron-down tool-caret"></i>
          </button>

          <div class="tool-menu check-menu" *ngIf="openDropdown === 'settlement_status'">
            <label class="check-item" *ngFor="let option of options.settlement_status">
              <input type="checkbox"
                     [checked]="isChecked('settlement_status', option.value)"
                     (change)="toggleOption('settlement_status', option.value)">
              <span>{{ option.label }}</span>
            </label>
          </div>
        </div>

        <!-- Lawyer -->
        <div class="tool-wrap" (click)="$event.stopPropagation()">
          <button class="tool-btn"
                  [class.has-value]="applied.lawyer_id.length"
                  (click)="toggleDropdown('lawyer_id', $event)">
            <span class="tool-text">
              {{ dropdownLabel('lawyer_id', 'Lawyer') }}
            </span>
            <i class="bi bi-chevron-down tool-caret"></i>
          </button>

          <div class="tool-menu check-menu scroll-menu" *ngIf="openDropdown === 'lawyer_id'">
            <label class="check-item" *ngFor="let option of options.lawyer">
              <input type="checkbox"
                     [checked]="isChecked('lawyer_id', option.value)"
                     (change)="toggleOption('lawyer_id', option.value)">
              <span>{{ option.label }}</span>
            </label>

            <div class="menu-empty" *ngIf="!options.lawyer.length">
              No lawyers in this period.
            </div>
          </div>
        </div>

      </div>

      <div class="filter-actions">
        <button class="btn btn-link btn-clear"
                [disabled]="!activeFilterCount && !searchQuery"
                (click)="clearFilters()">
          Clear
        </button>

        <button class="btn btn-apply" (click)="applyFilters()">
          Apply
        </button>
      </div>

    </div>

    <!-- ═══════════════ Table ═══════════════ -->
    <div class="clients-table" *ngIf="!loading && rows.length > 0">

      <table class="table">

        <thead>
          <tr>
            <th class="thdata">Client (Name)</th>
            <th class="thdata">Lawyer (Name)</th>

            <th class="thdata sortable-col" (click)="sortColumn('appointment_from')">
              Appointment Time
              <i class="bi sort-icon" [ngClass]="getSortIcon('appointment_from')"></i>
            </th>

            <th class="thdata sortable-col" (click)="sortColumn('appointment_status')">
              Appointment Status
              <i class="bi sort-icon" [ngClass]="getSortIcon('appointment_status')"></i>
            </th>

            <th class="thdata sortable-col" (click)="sortColumn('amount_paid')">
              Payment Made (₹)
              <i class="bi sort-icon" [ngClass]="getSortIcon('amount_paid')"></i>
            </th>

            <th class="thdata sortable-col" (click)="sortColumn('payment_status')">
              Payment Status
              <i class="bi sort-icon" [ngClass]="getSortIcon('payment_status')"></i>
            </th>

            <th class="thdata sortable-col" (click)="sortColumn('settlement_amount')">
              Settlement Amount (₹)
              <i class="bi sort-icon" [ngClass]="getSortIcon('settlement_amount')"></i>
            </th>

            <th class="thdata sortable-col" (click)="sortColumn('settlement_status')">
              Settlement Status
              <i class="bi sort-icon" [ngClass]="getSortIcon('settlement_status')"></i>
            </th>

            <th class="thdata">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let appointment of rows; trackBy: trackByAppointment">

            <!-- Client -->
            <td>
              <div class="client-name-wrap">
                <div class="fw-semibold">{{ appointment.client?.name || '-' }}</div>

                <small *ngIf="appointment.client?.email">
                  <i class="bi bi-envelope-fill"></i>&nbsp;
                  <a [href]="'mailto:' + appointment.client.email">
                    {{ appointment.client.email }}
                  </a>
                </small>

                <small *ngIf="appointment.client?.phone">
                  <i class="bi bi-telephone-fill"></i>&nbsp;
                  <a [href]="'tel:' + appointment.client.phone">
                    {{ appointment.client.phone }}
                  </a>
                </small>
              </div>
            </td>

            <!-- Lawyer -->
            <td>
              <div class="client-name-wrap">
                <div class="fw-semibold">{{ appointment.lawyer?.name || '-' }}</div>

                <small *ngIf="appointment.lawyer?.email">
                  <i class="bi bi-envelope-fill"></i>&nbsp;
                  <a [href]="'mailto:' + appointment.lawyer.email">
                    {{ appointment.lawyer.email }}
                  </a>
                </small>

                <small *ngIf="appointment.lawyer?.phone">
                  <i class="bi bi-telephone-fill"></i>&nbsp;
                  <a [href]="'tel:' + appointment.lawyer.phone">
                    {{ appointment.lawyer.phone }}
                  </a>
                </small>

                <small *ngIf="appointment.account_information">
                  <a class="acno"
                     [class.disabled]="!hasBankDetails(appointment)"
                     [attr.title]="hasBankDetails(appointment)
                                     ? 'View bank account details'
                                     : 'Lawyer has not added their bank details'"
                     (click)="openAccountCard(appointment, $event)">
                    Bank A/C Details
                  </a>

                  <div class="account-card"
                       *ngIf="selectedAccountId === appointment.appointment_id"
                       (click)="$event.stopPropagation()">

                    <div class="account-card-header">
                      <span>Bank Account Details</span>
                      <button class="close-btn" (click)="closeAccountCard()">
                        <i class="bi bi-x-lg"></i>
                      </button>
                    </div>

                    <div class="account-card-body">
                      <div class="detail-row">
                        <label>Account Holder</label>
                        <span>{{ appointment.account_information.account_holder_name || '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <label>Account Number</label>
                        <span>{{ appointment.account_information.account_number || '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <label>Bank Name</label>
                        <span>{{ appointment.account_information.bank_name || '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <label>IFSC Code</label>
                        <span>{{ appointment.account_information.ifsc_code || '-' }}</span>
                      </div>
                    </div>

                  </div>
                </small>
              </div>
            </td>

            <!-- Appointment time -->
            <td>
              <div class="time-cell">
                <div>{{ formatDate(appointment.appointment_from) }}</div>
                <small>{{ appointment.appointment_time }}</small>
              </div>
            </td>

            <!-- Appointment status -->
            <td>
              <span class="status-badge"
                    [ngClass]="getStatusClass(appointment.appointment_status)">
                {{ appointmentStatusLabel(appointment.appointment_status) }}
              </span>
            </td>

            <!-- Payment made -->
            <td>
              <div class="money-cell">
                <div class="fw-semibold">{{ money(appointment.amount_paid) }}</div>
                <small *ngIf="appointment.payment_breakdown?.platform_fee !== null"
                       [attr.title]="'Consultation ' + money(appointment.payment_breakdown?.consultation_fee)
                                     + ' · Platform fee ' + money(appointment.payment_breakdown?.platform_fee)
                                     + ' · GST ' + money(appointment.payment_breakdown?.gst)">
                  Includes GST, Platform Fee &amp; Service Fee
                </small>
              </div>
            </td>

            <!-- Payment status -->
            <td>
              <span class="status-badge"
                    [ngClass]="getPaymentStatusClass(appointment.payment_status)">
                {{ paymentStatusLabel(appointment.payment_status) }}
              </span>
            </td>

            <!-- Settlement amount -->
            <td>
              {{ appointment.settlement_status === 'refunded'
                   ? '-'
                   : money(appointment.settlement_amount) }}
            </td>

            <!-- Settlement status -->
            <td>
              <a *ngIf="appointment.settlement_status === 'completed'; else statusText"
                 class="status-badge settlement-link"
                 [ngClass]="getSettlementStatusClass(appointment.settlement_status)"
                 (click)="openSettlementDetails(appointment)">
                {{ settlementStatusLabel(appointment.settlement_status) }}
              </a>

              <ng-template #statusText>
                <span class="status-badge"
                      [ngClass]="getSettlementStatusClass(appointment.settlement_status)"
                      [attr.title]="appointment.settlement_status === 'pending' && appointment.settlement_due_at
                                      ? 'Settlement opens ' + formatDateTime(appointment.settlement_due_at)
                                      : null">
                  {{ settlementStatusLabel(appointment.settlement_status) }}
                </span>
              </ng-template>
            </td>

            <!-- Action -->
            <td>
              <div class="action-menu-wrap" (click)="$event.stopPropagation()">

                <button class="action-btn three-dot-btn"
                        (click)="toggleActionMenu(appointment.appointment_id, $event)"
                        title="Actions">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>

                <div class="action-dropdown"
                     *ngIf="activeMenuUid === appointment.appointment_id">

                  <button class="action-dd-item"
                          (click)="openNotesModal(appointment); activeMenuUid = null">
                    <i class="bi bi-chat-left-text"></i>
                    Add / View Notes
                  </button>

                  <button class="action-dd-item vbd"
                          [disabled]="!hasBankDetails(appointment)"
                          (click)="openBankDetails(appointment); activeMenuUid = null">
                    <i class="bi bi-receipt" style="font-size: 18px;"></i>
                    View Bank Details
                  </button>

                  <button class="action-dd-item"
                          *ngIf="appointment.settlement_status !== 'completed'"
                          [disabled]="!canSettle(appointment)"
                          [attr.title]="canSettle(appointment)
                                          ? null
                                          : 'Settlement has not been initiated yet'"
                          (click)="canSettle(appointment)
                                     && openSettlementModal(appointment); activeMenuUid = null">
                    <i class="bi bi-pencil-square" style="font-size: 18px;"></i>
                    Update Settlement Status
                  </button>

                  <button class="action-dd-item"
                          *ngIf="appointment.settlement_status === 'completed'"
                          (click)="openSettlementDetails(appointment); activeMenuUid = null">
                    <i class="bi bi-eye" style="font-size: 18px;"></i>
                    View Settlement Status
                  </button>

                </div>

              </div>
            </td>

          </tr>
        </tbody>

      </table>

    </div>

    <!-- ═══════════════ Skeleton loader ═══════════════ -->
    <div *ngIf="loading" class="skeleton-wrapper">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]">
        <div class="skeleton-cell wide"></div>
        <div class="skeleton-cell wide"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell medium"></div>
      </div>
    </div>

    <!-- ═══════════════ Empty state ═══════════════ -->
    <div *ngIf="!loading && rows.length === 0" class="empty-state">
      <i class="bi bi-calendar-x empty-icon"></i>

      <p class="empty-title">
        {{ searchQuery || activeFilterCount
             ? 'No appointments match these filters'
             : 'No appointments scheduled' }}
      </p>

      <p class="empty-sub">
        {{ searchQuery || activeFilterCount
             ? 'Try widening the date range or clearing a filter.'
             : 'There are no appointments in the selected period.' }}
      </p>
    </div>

    <!-- ═══════════════ Pagination ═══════════════ -->
    <div class="pagination-area" *ngIf="!loading && pagination.total > 0">

      <div class="pagination-info">
        {{ getPaginationRange() }}
      </div>

      <div class="pagination-controls">

        <nav>
          <ul class="pagination mb-0">

            <li class="page-item" [class.disabled]="pagination.page === 1">
              <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
                <i class="bi bi-chevron-left"></i>
              </a>
            </li>

            <li class="page-item"
                *ngFor="let page of getPageNumbers()"
                [class.active]="page === pagination.page">
              <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">
                {{ page }}
              </a>
            </li>

            <li class="page-item" [class.disabled]="pagination.page >= getTotalPages()">
              <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
                <i class="bi bi-chevron-right"></i>
              </a>
            </li>

          </ul>
        </nav>

        <select class="page-size"
                [ngModel]="pagination.limit"
                (ngModelChange)="changePageSize($event)">
          <option [ngValue]="10">10 / page</option>
          <option [ngValue]="20">20 / page</option>
          <option [ngValue]="50">50 / page</option>
          <option [ngValue]="100">100 / page</option>
        </select>

      </div>

    </div>

    <!-- ═══════════════ Update settlement modal ═══════════════ -->
    <div class="modal-backdrop" *ngIf="showSettlementModal" (click)="closeSettlementModal()"></div>

    <div class="modal-panel modal-plan" *ngIf="showSettlementModal">

      <div class="modal-header">
        <h6 class="modal-title">Update Settlement Status</h6>
        <button class="modal-close-btn" (click)="closeSettlementModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">

        <div class="mb-3" style="margin-bottom: -12px !important;">
          <label class="form-label fw-semibold labset">
            Status updated to Settlement Success.
          </label>
        </div>

        <div class="mt-4">
          <label class="form-label">
            Please Enter UTR Number <span class="text-danger">*</span>
          </label>

          <input type="text"
                 class="form-control"
                 maxlength="22"
                 [(ngModel)]="utrNumber"
                 placeholder="Enter UTR Number">
        </div>

        <div class="mt-4">
          <label class="form-label">Notes</label>

          <textarea rows="4"
                    maxlength="150"
                    class="form-control"
                    [(ngModel)]="settlementNotes"
                    placeholder="Enter notes"></textarea>

          <div class="d-flex justify-content-between align-items-center mt-1">
            <small class="text-muted">
              Please provide additional remarks for this settlement.
            </small>
            <small class="text-muted">
              {{ settlementNotes?.length || 0 }}/150
            </small>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button class="btn btn-cancel" (click)="closeSettlementModal()">
          Cancel
        </button>
        <button class="btn btn-primary"
                [disabled]="!utrNumber.trim() || savingSettlement"
                (click)="saveSettlement()">
          {{ savingSettlement ? 'Saving…' : 'Save Status' }}
        </button>
      </div>

    </div>

    <!-- ═══════════════ Settlement details modal ═══════════════ -->
    <div class="modal-backdrop" *ngIf="showSettlementDetailsModal" (click)="closeSettlementDetails()"></div>

    <div class="modal-panel modal-plan" *ngIf="showSettlementDetailsModal">

      <div class="modal-header">
        <h6 class="modal-title">Settlement Status Details</h6>
        <button class="modal-close-btn" (click)="closeSettlementDetails()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">

        <div class="detail-row">
          <label>Settlement Amount</label>
          <span>{{ money(selectedSettlement?.settlement_amount) }}</span>
        </div>

        <div class="detail-row">
          <label>UTR Number</label>
          <span>{{ selectedSettlement?.settlement_utr || '-' }}</span>
        </div>

        <div class="detail-row">
          <label>Date &amp; Time</label>
          <span>{{ formatDateTime(selectedSettlement?.settlement_date) }}</span>
        </div>

        <div class="detail-row" *ngIf="selectedSettlement?.settlement_notes">
          <label>Notes</label>
          <span>{{ selectedSettlement?.settlement_notes }}</span>
        </div>

      </div>

    </div>

    <!-- ═══════════════ Bank details modal ═══════════════ -->
    <div class="modal-backdrop" *ngIf="showBankDetailsModal" (click)="closeBankDetails()"></div>

    <div class="modal-panel modal-plan" *ngIf="showBankDetailsModal">

      <div class="modal-header">
        <h6 class="modal-title">Bank Account Details</h6>
        <button class="modal-close-btn" (click)="closeBankDetails()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">

        <div class="detail-row">
          <label>Account Holder</label>
          <span>{{ selectedBank?.account_information?.account_holder_name || '-' }}</span>
        </div>

        <div class="detail-row">
          <label>Account Number</label>
          <span>{{ selectedBank?.account_information?.account_number || '-' }}</span>
        </div>

        <div class="detail-row">
          <label>Bank Name</label>
          <span>{{ selectedBank?.account_information?.bank_name || '-' }}</span>
        </div>

        <div class="detail-row">
          <label>IFSC Code</label>
          <span>{{ selectedBank?.account_information?.ifsc_code || '-' }}</span>
        </div>

      </div>

    </div>

  </div>
</div>

<!-- ═══════════════ Notes modal ═══════════════ -->
<div class="modal-backdrop" *ngIf="showNotesModal" (click)="closeNotesModal()"></div>

<div class="modal-panel modal-plan" *ngIf="showNotesModal">

  <div class="modal-header">
    <h6 class="modal-title">
      <i class="bi bi-journal-text me-2"></i>
      Appointment Notes
    </h6>

    <button class="modal-close-btn" (click)="closeNotesModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">

    <div class="appointment-summary">
      <div class="summary-item">
        <label>Client</label>
        <span>{{ selectedAppointment?.client?.name }}</span>
      </div>

      <div class="summary-item">
        <label>Lawyer</label>
        <span>{{ selectedAppointment?.lawyer?.name }}</span>
      </div>

      <div class="summary-item">
        <label>Appointment</label>
        <span>{{ selectedAppointment?.appointment_time }}</span>
      </div>
    </div>

    <div class="form-group mt-4">
      <label class="form-label">Previous Notes</label>

      <div class="notes-history">

        <div class="note-card" *ngFor="let note of selectedAppointment?.notes">
          <div class="note-header">
            <strong>{{ note.created_by?.name || 'Admin' }}</strong>
            <span class="note-date">{{ note.created_on }}</span>
          </div>

          <div class="note-text">{{ note.note }}</div>
        </div>

        <div class="empty-state" *ngIf="!selectedAppointment?.notes?.length">
          No notes added yet.
        </div>

      </div>
    </div>

    <div class="form-group mt-4">
      <label class="form-label">Add Note</label>

      <textarea class="form-control"
                rows="4"
                [(ngModel)]="newNote"
                placeholder="Enter follow-up notes..."></textarea>
    </div>

  </div>

  <div class="modal-footer">
    <button class="btn btn-cancel" (click)="closeNotesModal()">
      Cancel
    </button>

    <button class="btn btn-primary"
            [disabled]="!newNote?.trim() || savingNote"
            (click)="saveNote()">
      {{ savingNote ? 'Saving…' : 'Save Note' }}
    </button>
  </div>

</div>

<ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate"
    [fullScreen]="true">
</ngx-spinner>
